/* ──────────────────────────────────────────────
 *  Groupes de l'étape lieu (bug 36) : les adresses,
 *  les lieux à distance (visio, téléphone) et les
 *  zones à domicile ne se mélangent plus.
 * ────────────────────────────────────────────── */

import { PlaceKind } from '@cfixe-monorepo/shared';
import type { PublicPlace } from '../types';

export type PlaceGroupKey = 'establishment' | 'remote' | 'traveling';

export interface PlaceGroup {
  key: PlaceGroupKey;
  places: PublicPlace[];
}

const GROUP_OF_KIND: Record<PlaceKind, PlaceGroupKey> = {
  [PlaceKind.ESTABLISHMENT]: 'establishment',
  [PlaceKind.PHONE]: 'remote',
  [PlaceKind.VIDEO]: 'remote',
  [PlaceKind.TRAVELING]: 'traveling',
};

const GROUP_ORDER: PlaceGroupKey[] = ['establishment', 'remote', 'traveling'];

/** Lieux groupés dans cet ordre (en établissement, à distance, à domicile), l'ordre du pro gardé dans chaque groupe ; groupes vides omis. */
export function groupPlacesByKind(places: PublicPlace[]): PlaceGroup[] {
  return GROUP_ORDER.map(
    (key): PlaceGroup => ({
      key,
      places: places.filter((place): boolean => (GROUP_OF_KIND[place.kind] ?? 'establishment') === key),
    }),
  ).filter((group): boolean => group.places.length > 0);
}
